// this was autogenerated by gulpTimezonePlugin from the timezone source in node_modules
(window.__PRELOADED_TIMEZONE_DATA__ || (window.__PRELOADED_TIMEZONE_DATA__ = {}))['en_CA']  = {
  "name": "en_CA",
  "day": {
    "abbrev": [
      "Sun",
      "Mon",
      "Tue",
      "Wed",
      "Thu",
      "Fri",
      "Sat"
    ],
    "full": [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ]
  },
  "month": {
    "abbrev": [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ],
    "full": [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ]
  },
  "meridiem": [
    "AM",
    "PM"
  ],
  "date": "%y-%m-%d",
  "time24": "%r",
  "dateTime": "%a %d %b %Y %r %Z",
  "time12": "%I:%M:%S %p",
  "full": "%a %b %e %H:%M:%S %Z %Y"
}

